<div class="form-grid" [formGroup]="tempForm">
  <vdr-form-field
    [label]="'coupon.lastLoginDays' | translate"
    for="lastLoginDays"
  >
    <input
      id="lastLoginDays"
      type="number"
      min="0"
      formControlName="lastLoginDays"
    />
  </vdr-form-field>

  <vdr-form-field
    [label]="'coupon.productsInCart' | translate"
    for="productsInCart"
  >
    <div style="width: 100%">
      <product-selector
        (productSelected)="onSelectProduct($event)"
      ></product-selector>

      <div style="display: flex; margin-top: 6px">
        <div
          *ngFor="let item of tempProductList"
          class="button-ghost"
          style="margin-left: 6px"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </vdr-form-field>

  <vdr-form-field
    [label]="'coupon.noOrderInDays' | translate"
    for="noOrderInDays"
  >
    <input
      id="noOrderInDays"
      type="number"
      min="0"
      formControlName="noOrderInDays"
    />
  </vdr-form-field>

  <div>
    <div style="display: grid; grid-template-columns: 1fr 2fr">
      <vdr-form-field [label]="'Currency Code' | translate" style="width: 100%">
        <div style="width: 80%">
          <single-currency-code-selector formControlName="currencyCode">
          </single-currency-code-selector>
        </div>
      </vdr-form-field>

      <vdr-form-field
        [label]="'coupon.totalPurchaseAmount' | translate"
        for="totalPurchaseAmount"
        style="width: 100%"
      >
        <input
          id="totalPurchaseAmount"
          type="number"
          min="0"
          formControlName="totalPurchaseAmount"
        />
      </vdr-form-field>
    </div>
    <div style="color: red; margin-top: 6px">{{ errorMessage }}</div>
  </div>
</div>

<div style="display: flex; margin-top: 1rem">
  <button class="button primary" (click)="applyFilter()">Apply filters</button>
  <button
    style="margin-left: 6px"
    class="button secondary"
    (click)="clearFilter()"
  >
    Clear filters
  </button>
</div>

<table class="table">
  <thead>
    <tr>
      <th>
        <input
          type="checkbox"
          clrCheckbox
          [checked]="areAllCurrentItemsSelected()"
          (change)="onToggleAllClick($event)"
        />
      </th>
      <th>{{ "common.id" | translate }}</th>
      <th>{{ "customer.first-name" | translate }}</th>

      <th>{{ "coupon.totalPurchaseAmount" | translate }}</th>

      <th>
        {{ "common.created-at" | translate }}
      </th>

      <th>
        {{ "customer.last-login" | translate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let customer of customers$ | async">
      <td>
        <input
          type="checkbox"
          clrCheckbox
          [checked]="isItemSelected(customer.id)"
          (change)="selectItem(customer)"
        />
      </td>

      <td>
        {{ customer.id }}
      </td>

      <td>
        {{ customer.firstName }}
      </td>

      <td>
        {{
          customer.customFields.moneySpent ?? 0
            | localeCurrency
              : customer.customFields.customerCountry.country.customFields
                  .currencyCode
        }}
      </td>

      <td>
        {{ customer.createdAt | localeDate : "short" }}
      </td>

      <td>
        <div *ngIf="customer.user?.lastLogin; else noLogin">
          {{ customer.user.lastLogin | localeDate : "short" }}
        </div>
        <ng-template #noLogin> * </ng-template>
      </td>
    </tr>

    <ng-container>
      <tr *ngIf="(customers$ | async)?.length <= 0">
        <td [attr.colspan]="5">
          <vdr-empty-placeholder
            [emptyStateLabel]="emptyStateLabel"
          ></vdr-empty-placeholder>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<div class="paging-controls" *ngIf="(customers$ | async)?.length > 0">
  <custom-items-per-page-controls
    [itemsPerPage]="paginationConfig.itemsPerPage"
    (itemsPerPageChange)="itemsPerPageChange($event)"
  ></custom-items-per-page-controls>

  <custom-pagination-controls
    [currentPage]="paginationConfig.currentPage"
    [itemsPerPage]="paginationConfig.itemsPerPage"
    [totalItems]="paginationConfig.totalItems"
    (pageChange)="pageChange($event)"
  ></custom-pagination-controls>
</div>
